<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">

      <el-tag type="danger" size="small">警告：请勿随意变更金蝶的对接信息配置，否则将会导致系统信息同步至金蝶出错</el-tag>

      <el-form :inline="true" class="backborder1 demo-form-inline cz-kingdeeconfig" size="small" style="margin-top:10px">
          <el-form-item label-width="120" label="金蝶组织码" style="width:100%">
              <el-input placeholder="请输入金蝶组织码" v-model="query.orgnzcode" @blur="changekingdeeconfig"></el-input>
          </el-form-item>
          <el-form-item label-width="120" label="金蝶webapi地址" style="width:100%">
              <el-input placeholder="请输入金蝶组织码" v-model="query.webapiurl" @blur="changekingdeeconfig"></el-input>
          </el-form-item>
          <el-form-item label-width="120" label="金蝶账套Id" style="width:100%">
              <el-input placeholder="请输入金蝶组织码" v-model="query.accessid" @blur="changekingdeeconfig"></el-input>
          </el-form-item>
          <el-form-item label-width="120" label="金蝶登录用户名" style="width:100%">
              <el-input placeholder="请输入金蝶登录用户名" v-model="query.username" @blur="changekingdeeconfig"></el-input>
          </el-form-item>
          <el-form-item label-width="120" label="金蝶登录用户密码" style="width:100%">
              <el-input placeholder="请输入金蝶登录用户密码" v-model="query.password" @blur="changekingdeeconfig"></el-input>
          </el-form-item>
          <el-form-item label-width="120" label="是否启用自动同步数据" style="width:100%">
              <el-tooltip class="item" effect="dark" content="开关开打时，商品、客户、供应商信息在新增时会自动同步到金蝶" placement="top">
              <el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="query.isaddsysn" @change="changekingdeeconfig"></el-switch>
              </el-tooltip>
          </el-form-item>
          
      </el-form>
      

  </div>
  </transition> 
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Kingdee/index",
      transitionshow:true,
      actionauth:'',
      query: {
        act:'getkingdeesetting',
        token:this.$cookies.get('token'),
        orgnzcode:'',
        accessid:'',
        username:'',
        password:'',
        webapiurl:'',
        isaddsysn:'',
        loading:false,
      },
      

    }
  },

  mounted(){  
  	this.getactionauth(); //获取权限设置
    this.getkingdeeconfig(); //获取关联金蝶的配置信息
  },

  methods:{ 
      /** 获取操作功能权限 **/
  	  getactionauth() {
    	    var data =this.$cookies.get('actionauth');
    	    data=JSON.parse(data);
          this.actionauth=data;
      },

      /** 获取关联金蝶的配置信息 **/
      getkingdeeconfig() {
          this.query.loading=true;
          var resource = this.$resource(this.url);
          resource.query({act:'getkingdeeconfig',token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login');
                  this.$message.error(res.data.Message);
                  this.query.loading=false;
              }else{
                  var result=JSON.parse(Base64.decode(res.data.Data));
                  this.query.orgnzcode=result.orgnzcode;
                  this.query.accessid=result.accessid;
                  this.query.username=result.username;
                  this.query.password=result.password;
                  this.query.webapiurl=result.webapiurl;
                  this.query.isaddsysn=result.isaddsysn==1 ? true : false;
                  this.query.loading=false;
              }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
              this.query.loading=false;
          });
      },

      /** 修改金蝶配置信息 **/
      changekingdeeconfig() {
          var resource = this.$resource(this.url);
          resource.save({act:'updateconfigfromkingdee',webapiurl:this.query.webapiurl,orgnzcode:this.query.orgnzcode,
                         accessid:this.query.accessid,username:this.query.username,password:this.query.password,isaddsysn:this.query.isaddsysn ? 1 : 0,
                         token:this.$cookies.get('token')}).then((res) => {
            if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login');
                  this.$message.error(res.data.Message);
              }else{

              }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
          });
      },
      

  },

}
</script>
<style>
.cz-kingdeeconfig .el-form-item__content{width:20%}
.kingdee-sysn-add-warning {display:flex;font-size:12px;color:#666666;width:18px;height:18px;border-radius:50%;justify-content:center;align-items:center;background:#e6a23c}
</style>


// WEBPACK FOOTER //
// src/components/kingdee/KDcompy.vue